import { render } from "./BankWatchSidebar.vue?vue&type=template&id=11e2299f&scoped=true&ts=true"
import script from "./BankWatchSidebar.vue?vue&type=script&lang=ts"
export * from "./BankWatchSidebar.vue?vue&type=script&lang=ts"

import "./BankWatchSidebar.vue?vue&type=style&index=0&id=11e2299f&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11e2299f"]])

export default __exports__